import { render, staticRenderFns } from "./Entity.vue?vue&type=template&id=63635734&scoped=true&"
import script from "./Entity.vue?vue&type=script&lang=js&"
export * from "./Entity.vue?vue&type=script&lang=js&"
import style0 from "@/assets/fluid-wider.css?vue&type=style&index=0&id=63635734&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63635734",
  null
  
)

export default component.exports